import angular from 'angular';

(function () {
    'use strict';
    angular.module('app.core').factory('Audit', AuditData);

    function AuditData() {
        Audit.prototype = {
            build: build,
            buildEmpty: buildEmpty,
        };

        function Audit(auditData) {
            if (!auditData) {
                this.buildEmpty();
            } else {
                this.build(auditData);
            }
        }

        return Audit;

        /////////////////////

        function buildEmpty() {
            this.id = null;
            this.userId = null;
            this.date = null;
            this.action = null;
            this.context = null;
            this.contextId = null;
            this.param1 = null;
            this.param2 = null;
            this.param3 = null;
            this.param4 = null;
            this.param5 = null;
            this.param6 = null;
            this.param7 = null;
            this.param8 = null;
            this.userLogin = null;
        }

        function build(auditData) {
            this.id = auditData.id || null;
            this.userId = auditData.userId || null;
            this.date = auditData.creationDate || null;
            this.action = auditData.action || null;
            this.context = auditData.context || null;
            this.contextId = auditData.contextId || null;
            this.param1 = auditData.param1 || null;
            this.param2 = auditData.param2 || null;
            this.param3 = auditData.param3 || null;
            this.param4 = auditData.param4 || null;
            this.param5 = auditData.param5 || null;
            this.param6 = auditData.param6 || null;
            this.param7 = auditData.param7 || null;
            this.param8 = auditData.param8 || null;
            this.userLogin = auditData.userLogin || null;
        }
    }
})();
